import mapToObject from '../util/map-to-object';

const HotelMetricsProperties = [
  'Clicks',
  'Impressions',
  'CTR',
  'Spend',
  'SpendUSD',
  'AverageCPC',
  'AverageCPCUSD',
  'AveragePosition',
  'ConversionRate',
  'Conversions',
  'CPA',
  'GrossRevenue',
  'GrossRevenuePerClick',
  'GrossRevenuePerConv',
  'GrossROAS',
  'NetRevenue',
  'NetRevenuePerClick',
  'NetRevenueConv',
  'NetROAS',
  'TotalBookedNights',
  'AvgBookedABW',
  'AvgBookedNights',
  'BookedABW',
];

export default mapToObject(
  HotelMetricsProperties,
  property => `Metrics/${property}`
);
